import { render, staticRenderFns } from "./payment-and-banking.page.vue?vue&type=template&id=309c2864&"
import script from "./payment-and-banking.page.vue?vue&type=script&lang=ts&"
export * from "./payment-and-banking.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports